module.exports = __webpack_public_path__ + "static/media/gymet_5.a3887115.png";